module.exports = __webpack_public_path__ + "media/images/static/line/minute-118568d200460830957180548d0844ef.png";